import { render } from "./BookEntry.vue?vue&type=template&id=2137c781&scoped=true"
import script from "./BookEntry.vue?vue&type=script&lang=js"
export * from "./BookEntry.vue?vue&type=script&lang=js"

import "./BookEntry.vue?vue&type=style&index=0&id=2137c781&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2137c781"]])

export default __exports__